import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Network/Remote_Access/SuccessBox';
import RemoteTable from 'components/Web_User_Interface/1080p_Series/Network/Remote_Access/remoteTable';
import DangerBox from 'components/Web_User_Interface/1080p_Series/Network/Remote_Access/DangerBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  RemoteTable,
  DangerBox,
  BreadCrumbs,
  SEOHelmet,
  React
};